import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '../assets/Images/Videos/Video-Residential.mp4'
import _imports_1 from '../assets/Images/Videos/Video-Investment.mp4'
import _imports_2 from '../assets/Images/logoRealtorToolsHeader2.png'
import _imports_3 from '../assets/Images/logo02.png'
import _imports_4 from '../assets/Images/arrow-down.svg'


const _hoisted_1 = { class: "site-header" }
const _hoisted_2 = { class: "hidden-mobile" }
const _hoisted_3 = { class: "realtors-target" }
const _hoisted_4 = { class: "container-fixed" }
const _hoisted_5 = {
  class: "modal fade",
  id: "modalProducts",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_6 = { class: "modal-dialog modal-xl" }
const _hoisted_7 = { class: "modal-content" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close custom-close-button",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_9 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("video", {
  src: _imports_0,
  class: "tw-w-full",
  controls: "",
  autoplay: ""
}, null, -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("video", {
  src: _imports_1,
  class: "tw-w-full",
  controls: "",
  autoplay: ""
}, null, -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "realtors-target__navbar" }
const _hoisted_17 = { class: "navbar navbar-expand-lg d-flex justify-content-between" }
const _hoisted_18 = {
  class: "collapse navbar-collapse d-flex justify-content-between",
  id: "navbarTogglerDemo01"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("a", {
  class: "navbar-brand",
  href: "/"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: ""
  })
], -1)
const _hoisted_20 = { class: "form-inline my-2 my-lg-0" }
const _hoisted_21 = { class: "navbar-nav mr-auto mt-2 mt-lg-0 d-flex align-items-center" }
const _hoisted_22 = { class: "nav-item active tw-pr-[40px]" }
const _hoisted_23 = { class: "nav-item active tw-pr-[26px] tw-pl-[2px]" }
const _hoisted_24 = { class: "nav-item active tw-pr-[26px] tw-pl-[2px]" }
const _hoisted_25 = { class: "nav-item active pr-4 tw-relative" }
const _hoisted_26 = { class: "dropdown tw-block tw-relative" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("a", {
  class: "tw-bg-transparent tw-text-[#606060] tw-flex tw-justify-between tw-w-[150px] tw-items-center",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createTextVNode(" PRODUCTS "),
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-caret-down tw-pb-0.5" })
], -1)
const _hoisted_28 = { class: "dropdown-menu" }
const _hoisted_29 = { class: "nav-item tw-pr-[45px] tw-pl-[30px]" }
const _hoisted_30 = { class: "nav-item dropdown" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("a", {
  class: "nav-link dropdown-toggle",
  href: "#",
  id: "navbarDropdownMenuLink",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, " SIGN UP ", -1)
const _hoisted_32 = {
  class: "dropdown-menu",
  "aria-labelledby": "navbarDropdownMenuLink"
}
const _hoisted_33 = ["href"]
const _hoisted_34 = { class: "visible-mobile" }
const _hoisted_35 = { class: "navbar navbar-expand-lg navbar-light bg-light" }
const _hoisted_36 = { class: "container-fluid" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("a", {
  class: "navbar-brand",
  href: "/"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "tw-w-[100px]",
    src: _imports_3,
    alt: ""
  })
], -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("button", {
  class: "navbar-toggler",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#navbarNavDropdown",
  "aria-controls": "navbarNavDropdown",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" })
], -1)
const _hoisted_39 = {
  class: "collapse navbar-collapse",
  id: "navbarNavDropdown"
}
const _hoisted_40 = { class: "navbar-nav tw-text-left tw-mt-5" }
const _hoisted_41 = { class: "nav-item" }
const _hoisted_42 = { class: "nav-item tw-mt-3" }
const _hoisted_43 = { class: "nav-item tw-mt-3" }
const _hoisted_44 = { class: "nav-item d-flex justify-content-left tw-mt-3" }
const _hoisted_45 = { class: "dropdown tw-block tw-relative" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("a", {
  class: "tw-text-[#606060] tw-flex tw-justify-between tw-w-[120px] tw-items-center",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createTextVNode(" PRODUCTS"),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    alt: ""
  })
], -1)
const _hoisted_47 = {
  class: "dropdown-menu",
  style: {"width":"150px !important","font-size":"12px"}
}
const _hoisted_48 = { class: "nav-item tw-mt-3" }
const _hoisted_49 = { class: "nav-item tw-mt-1" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("a", {
  class: "nav-link dropdown-toggle tw-text-[#606060] tw-font-bold tw-flex tw-gap-[19px]",
  href: "#",
  id: "navbarDropdownMenuLink",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createTextVNode(" SIGN UP"),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    alt: ""
  })
], -1)
const _hoisted_51 = {
  class: "dropdown-menu",
  "aria-labelledby": "navbarDropdownMenuLink"
}
const _hoisted_52 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_routerLink = _resolveComponent("routerLink")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                (_ctx.productSelected)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      (_ctx.productSelected.toString() == '1')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
                        : _createCommentVNode("", true),
                      (_ctx.productSelected.toString() == '2')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("nav", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createElementVNode("form", _hoisted_20, [
                  _createElementVNode("ul", _hoisted_21, [
                    _createElementVNode("li", _hoisted_22, [
                      _createVNode(_component_routerLink, { to: "/" }, {
                        default: _withCtx(() => [
                          _createTextVNode("HOME")
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", _hoisted_23, [
                      _createVNode(_component_routerLink, { to: "/about-us" }, {
                        default: _withCtx(() => [
                          _createTextVNode("ABOUT US")
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", _hoisted_24, [
                      _createVNode(_component_routerLink, { to: "/target" }, {
                        default: _withCtx(() => [
                          _createTextVNode("TARGET")
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", _hoisted_25, [
                      _createElementVNode("a", _hoisted_26, [
                        _hoisted_27,
                        _createElementVNode("ul", _hoisted_28, [
                          _createElementVNode("li", null, [
                            _createElementVNode("a", {
                              class: "dropdown-item",
                              href: "#",
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openModal('modalProducts', '1')))
                            }, "RESIDENTIAL")
                          ]),
                          _createElementVNode("li", null, [
                            _createElementVNode("a", {
                              class: "dropdown-item",
                              href: "#",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openModal('modalProducts', '2')))
                            }, "INVESTMENT")
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_29, [
                      _createVNode(_component_routerLink, { to: "/loginusers" }, {
                        default: _withCtx(() => [
                          _createTextVNode("LOG IN ")
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", _hoisted_30, [
                      _hoisted_31,
                      _createElementVNode("ul", _hoisted_32, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listRoles, (role, index) => {
                          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                            (role.name != 'ADMIN')
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  class: "dropdown-item",
                                  id: "option",
                                  href: '/register?type=' + role.idRole
                                }, _toDisplayString(role.name), 9, _hoisted_33))
                              : _createCommentVNode("", true)
                          ], 64))
                        }), 128))
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_34, [
      _createElementVNode("nav", _hoisted_35, [
        _createElementVNode("div", _hoisted_36, [
          _hoisted_37,
          _hoisted_38,
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("ul", _hoisted_40, [
              _createElementVNode("li", _hoisted_41, [
                _createVNode(_component_routerLink, {
                  class: "tw-text-[#606060]",
                  to: "/"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("HOME")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_42, [
                _createVNode(_component_routerLink, {
                  class: "tw-text-[#606060]",
                  to: "/about-us"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("ABOOT US")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_43, [
                _createVNode(_component_routerLink, {
                  class: "tw-text-[#606060]",
                  to: "/target"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("TARGET")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_44, [
                _createElementVNode("a", _hoisted_45, [
                  _hoisted_46,
                  _createElementVNode("ul", _hoisted_47, [
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        href: "#",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openModal('modalProducts', '1')))
                      }, "RESIDENTIAL")
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        href: "#",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openModal('modalProducts', '2')))
                      }, "INVESTMENT")
                    ])
                  ])
                ])
              ]),
              _createElementVNode("li", _hoisted_48, [
                _createVNode(_component_routerLink, {
                  class: "tw-text-[#606060]",
                  to: "/loginusers"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("LOG IN ")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_49, [
                _hoisted_50,
                _createElementVNode("ul", _hoisted_51, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listRoles, (role, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                      (role.name != 'ADMIN')
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            class: "dropdown-item",
                            style: {"font-size":"12px"},
                            id: "option",
                            href: '/register?type=' + role.idRole
                          }, _toDisplayString(role.name), 9, _hoisted_52))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}